var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"frame",staticClass:"frame-image",style:({ backgroundImage: ("url(" + (encodeURI(_vm.imageUrl)) + ")"), backgroundPosition: _vm.backgroundPosition, transform: ("scale(" + _vm.z + ")"), transformOrigin: _vm.transformOrigin })})}
var staticRenderFns = []

export { render, staticRenderFns }